export default __webpack_public_path__ + "static/media/Enlightened Loop.f76ddc7d.jpg";